export default {
	props:{
		images: Array,
	},
	data(){
		return {
			swiper: null,
		}
	},
	computed:{
		cp_numImages(){
			return this.images.length;
		}
	},
	methods: {
		init(){
			let self = this;

			this.swiper = new Swiper (this.$el.querySelector('.swiper-container'), {
				loop:true,
				spaceBetween: 0,
				initialSlide: 0,
				keyboard:true,
				grabCursor:true,
				// Disable preloading of all images
				preloadImages: false,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				lazy: {
					loadPrevNext: true,
				},
			});
		},
	},
	mounted(){
		let self = this;
		ITTI.defer(function (){
			self.init();
		}, ['swiperJS']);
	},
	beforeDestroy(){
		if(this.swiper) {
			this.swiper.destroy();
			this.swiper = null;
		}
	},
	template: `
<div class="gallery-swiper">
	<div class="swiper-container">
		<div class="swiper-wrapper">
			<div class="swiper-slide img16x9" v-for="(src,i) in images" :key="i">
				<img :data-src="src" class="swiper-lazy">
			</div>
		</div>
		<div class="swiper-button-next swiper-button-white"></div>
		<div class="swiper-button-prev swiper-button-white"></div>
	</div>
	<div class="gallery-camera-btn camera__btn">
		<span class="num">{{cp_numImages}}</span>
		<span class="qicon-1">camera</span>
	</div>
</div>
`,
}
